import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import toasted from "../config/toasted";

const AdultWarningModal = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const accepted = localStorage.getItem("adultModalAccepted");
        if (!accepted) setShow(true);
    }, []);

    const handleAccept = () => {
        localStorage.setItem("adultModalAccepted", "yes");
        setShow(false);
        toasted.success("Welcome to the adult prompts section! 😈");
    };

    if (!show) return null;

    return (
        <>
            <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: '#000' }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">⚠️ Adult Content Warning</h5>
                        </div>

                        <div className="modal-body">
                            <p>
                                This page contains <strong>18+ text-based fantasy content</strong>
                                intended strictly for consenting adults.
                            </p>

                            <ul>
                                <li>You must be at least <strong>18 years old</strong> to continue.</li>
                                <li>All characters and scenarios are fictional.</li>
                                <li>No real persons are depicted or implied.</li>
                            </ul>

                            <p>
                                By proceeding, you confirm that you meet the age requirement
                                and accept full responsibility for viewing this content.
                            </p>
                        </div>


                        <div className="modal-footer">
                            <Link to="/" className="btn btn-secondary"> I am under 18 </Link>
                            <button className="btn btn-danger" onClick={handleAccept} > I am 18 or older </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Backdrop */}
            <div className="modal-backdrop fade show"></div>
        </>
    );
};

export default AdultWarningModal;
